import {H1, H1Dashboard} from '@hm/fundamental'
import React from 'react'

export interface BreadcrumbSegmentProps {
  isActive: boolean
  onClick?: () => void
  children: React.ReactNode
}

export const BreadcrumbSegment: React.FC<BreadcrumbSegmentProps> = ({
  isActive,
  onClick,
  children
}) => {
  const clickableClass = onClick ? ' cursor-pointer hover:opacity-80' : ''
  const props = {
    className: `text-foreground${clickableClass}`,
    'data-test-id': 'feature_breadcrumb_segment',
    ...(onClick && {onClick, role: 'link'})
  }
  return isActive ? (
    <H1 {...props}>{children}</H1>
  ) : (
    <H1Dashboard {...props}>{children}</H1Dashboard>
  )
}
